import React from 'react';
import style from './style.module.scss';
import {motion, AnimatePresence} from 'framer-motion'


interface NullProps { 
  setNotResult: (arg: boolean) => void,
  setSearchValue: (arg: string) => void,
  notResult: boolean
}
export const Null = ({ setNotResult, setSearchValue,notResult } : NullProps) => {
  const handleCloseModal = () => {
    setNotResult(false);
    setSearchValue('');
  };
  return (
    <AnimatePresence>
    {notResult && ( 
      <motion.div
        initial={{ opacity: 0 }} // Начальное состояние (невидим)
        animate={{ opacity: 1 }} // Анимация появления
        exit={{ opacity: 0 }} // Анимация исчезновения
        transition={{ duration: 0.3 }} // Длительность анимации
        className={style.null}
      >
        <div className={style.top}>
          <h4 className={style.title}>
            По вашему запросу ничего не найдено
          </h4>
        </div>
        <button onClick={handleCloseModal} className={style.button}>
          Ок
        </button>
      </motion.div>
    )}
  </AnimatePresence>
  );
};
